export default __webpack_public_path__ + "static/media/privacy.5e9e5713.md";